import React, { useCallback } from "react";
import { inject, observer } from "mobx-react";
import TableSettings from "../tables/TableSettings";
import { IAppStore } from "../../stores/Interfaces";

interface Props {
  store?: IAppStore;
  reorderable?: boolean;
}

const Settings: React.FC<Props> = ({
  store: { settingsStore } = {},
  reorderable,
}) => {
  const onChangeScrollbarHandler = useCallback(
    (value: boolean) => {
      if (settingsStore) {
        settingsStore.isEnabledScrollbar = value;
      }
    },
    [settingsStore]
  );

  const onReorderChangeVisibilityHandler = useCallback(
    (value: boolean) => {
      if (settingsStore) {
        settingsStore.isEnabledReorder = value;
      }
    },
    [settingsStore]
  );

  return (
    <TableSettings
      reorderable={reorderable}
      isScrollbarVisible={settingsStore?.isEnabledScrollbar || false}
      onChangeScrollbarVisibility={onChangeScrollbarHandler}
      isReorderEnabled={settingsStore?.isEnabledReorder || false}
      onReorderChangeVisibility={onReorderChangeVisibilityHandler}
    />
  );
};

export default inject("store")(observer(Settings));
